/**
 * @fileoverview shared API configuration for solarIQ
 * 
 * centralization of config declarations
 */

export const AI_ENDPOINT = "/ai";
export const apiHeaders = () => ({ "Content-Type": "application/json" });